import React, {memo} from "../../../__snowpack__/pkg/react.js";
import {Affix} from "../../../__snowpack__/pkg/antd.js";
import styled from "../../../__snowpack__/pkg/styled-components.js";
import {isEmpty} from "../../../__snowpack__/pkg/lodash.js";
const AffixFixedStyled = styled.div`
  .Affix {
    &-box {
      padding-top: 14px;
      padding-bottom: 14px;
      background: #ffffff;
      text-align: ${(props) => props.TextAlign ? "left" : "center"};
      .ant-btn {
        margin-right: 16px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    &-default-box {
      padding: 14px 16px;
      background: #ffffff;
      box-shadow: 0 2px 3px -2px rgba(24, 24, 24, 0.3);
    }
  }
`;
const defaultFixed = ({FixedLeft, IsBorderTop}) => {
  return {
    position: "fixed",
    zIndex: 2,
    right: 0,
    left: FixedLeft + "px",
    bottom: 0,
    borderTop: IsBorderTop ? null : "10px solid #f0f2f5ff"
  };
};
export const AffixFixed = memo((props) => {
  const {offsetBottom, IsBorderTop, propsStyles, propsStylesForce, offsetTop, IsClassName, targetNode, TextAlign} = props;
  return /* @__PURE__ */ React.createElement(AffixFixedStyled, {
    IsBorderTop,
    FixedLeft: 72,
    TextAlign
  }, /* @__PURE__ */ React.createElement(Affix, {
    className: "Affix",
    offsetTop,
    offsetBottom,
    target: targetNode,
    style: isEmpty(propsStyles) ? defaultFixed({IsBorderTop, FixedLeft: 72}) : Object.assign({}, propsStyles, propsStylesForce ? {} : {left: 72, top: 46, right: 0})
  }, /* @__PURE__ */ React.createElement("div", {
    className: IsClassName ? "Affix-default-box" : "Affix-box"
  }, props.children)));
});
